module.exports = __webpack_public_path__ + "static/panels-1-9846ce3eaad1752c5ca7cf8decbe2373.png";